import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from 'primereact/confirmdialog';

import { Button, Table } from "../../helpers";
import Loading from "../../common/Loading";
import RaiseIssueModal from "./components/RaiseIssueModal";

import { getNotifications, updateNotificationStatusById } from "../../services/api/adminNotificationMessage";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getFullName } from "../../utils";

import "./index.css";
import { fetchPriorities, fetchStatus } from "../../services/redux/reducers/commonThunk";


const AdminMessageNotification = () => {
    const [isRaiseIssueModalVisible, setIsRaiseIssueModalVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [notifications, setNotifications] = useState([])

    const priorities = useSelector((state) => state.common.priorities)
    const status = useSelector((state) => state.common.status)
    
    const dispatch = useDispatch()

    const companyUsers = useSelector((state) => state.userDetails.PMCompanyDetails.companyUsers)
    
    useEffect(() => {
        dispatch(fetchPriorities())
        dispatch(fetchStatus())
        fetchNotifications()
    }, [])

    const fetchNotifications = async () => {
        const searchParams = {
            statusIds: [17, 18, 4],
            notificationTypeIds: [2],
            paginator: false
        }

        const notificationRes = await getNotifications(searchParams)
        if (notificationRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: notificationRes.data.error }))
        }

        setNotifications(notificationRes.data.data)
    }

    const getUserNameBody = (row) => {
        return getFullName(row.users?.firstName, row.users?.lastName)
    }

    const getPriorityBody = (row) => {
        const relatedPriority = priorities.find(eachPriority => eachPriority.priorityId === row.priorityId)
        return relatedPriority ? relatedPriority.priority : "N/A"
    }

    const getStatusBody = (row) => {
        const relatedStatus = status.find(eachPriority => eachPriority.statusId === row.statusId)
        return relatedStatus ? relatedStatus.status.charAt(0).toUpperCase() + relatedStatus.status.slice(1) : "N/A"
    }

    const getUpdatedAtBody = (row) => moment(row.updatedAt).format("DD MMM h:mm A")

    const getRaisedByBody = (row) => {
        const raisedByUser = companyUsers.find(eachUser => eachUser.userId === row.createdBy)
        return (
            <div>
                <p className="m-0">{raisedByUser && getFullName(raisedByUser.firstName, raisedByUser.lastName)}</p>
                <p className="m-0" style={{fontSize: "12px"}}>{moment(row.createdAt).format("DD MMM h:mm A")}</p>
            </div>
        )
    }    

    const handleDismiss = async (row) => {
        const updateObj = { 
            statusId: 19
        }

        const response = await updateNotificationStatusById(row.notificationId, updateObj)

        if (response.failure) {
            return dispatch(raiseToast({severity:'error', detail: response.data.error}))
        } else {
            const updatedNotifications = notifications.filter(eachNotification => eachNotification.notificationId !== row.notificationId)
            setNotifications(updatedNotifications)
        }
    }

    const getActionsBody = (row) => {
        const confirmDismiss = () => {
            confirmDialog({
                message: 'Are you sure you want to dismiss this notification?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => handleDismiss(row), 
                reject: () => {
                    console.log('Dismiss canceled')
                }
            })
        }
    
        return (
            <div>
                <Button onClick={confirmDismiss}>Dismiss</Button>
            </div>
        )
    }

    const rowClass = (row) => {
        return {
            'status-inprogress': row.status === 'inprogress',
            'status-todo': row.status === 'todo',
            'status-closed': row.status === 'closed'
        }
    }

    const tableColumns = [
        {
            header: 'Notification ID', field: 'notificationId', style:{ textAlign: "center", minWidth: "80px", paddingTop: "15px", paddingBottom: "15px" }
        },
        {
            header: 'User Name', body: getUserNameBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Title', field: 'message', style:{ textAlign: "center", minWidth: "200px" }
        },
        {
            header: 'Priority', body: getPriorityBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Status', body: getStatusBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Escalation Type', field: 'escalationType', style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Comment', field: 'comment', style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Raised By', body: getRaisedByBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Updated At', body: getUpdatedAtBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Action', body: getActionsBody, style:{ textAlign: "center", minWidth: "120px" }
        }
    ]

    return (
        <div>
            <div className="vp-cheque-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">EMERGENCY ISSUES</h4>
                    <div className="flex justify-content-end mb-2">
                        <div>
                            <Button icon="pi pi-pencil" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Raise Issue" onClick={() => { setIsRaiseIssueModalVisible(!isRaiseIssueModalVisible) }} />
                        </div>
                    </div>
                </div>

                <div className='flex flex-row'>
                    <div className="vp-cheque-table" style={{ width: "100%" }}>
                        <div className='p-card mb-0' >
                            <div className="flex-grow-1" >
                                <Table
                                    lazy
                                    tableColumns={tableColumns}
                                    rowClassName={rowClass}
                                    data={notifications}
                                    scrollable={"true"}
                                    scrollHeight="550px"
                                    loading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog header="RAISE ISSUE" visible={isRaiseIssueModalVisible} className="admin_notification_raise_issue" style={{ maxHeight: '60%', backgroundColor: '#f8f8f8' }} onHide={() => setIsRaiseIssueModalVisible(false)}>
                    <RaiseIssueModal 
                        setIsLoading={setIsLoading} 
                        setNotifications={setNotifications} 
                        notifications={notifications}
                        setIsRaiseIssueModalVisible={setIsRaiseIssueModalVisible}
                    />
                </Dialog>

                <Loading visible={isLoading} />
            </div>
        </div>
    )
}

export default AdminMessageNotification;
